import { Options, useMixins } from '@/modules/booster/model/mixins';

export function useBoosterItemEdit() {
    const { v$, model, fetch, actions } = useMixins();

    return { v$, model, fetch, actions, Options };
}
